import React, { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";
import { useConfig } from "@/lib/useConfig";

const STORAGE_KEY = "waii_promo_launch50_dismissed";

export default function PromoBanner() {
  const { promoEnabled } = useConfig();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(localStorage.getItem(STORAGE_KEY) !== "1");
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!promoEnabled || !visible) return null;

  return (
    <div
      data-testid="promo-banner"
      className="relative bg-gradient-to-r from-[#B45309] via-[#F59E0B] to-[#FBBF24] text-[#3b2402]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2.5 flex items-center justify-center gap-2 text-center">
        <Sparkles className="w-4 h-4 shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm font-semibold leading-snug">
          <span className="font-extrabold">Launch Special — 50% off all listings.</span>{" "}
          Enter code{" "}
          <span className="font-mono font-extrabold bg-[#3b2402] text-[#FBBF24] px-1.5 py-0.5 rounded" data-testid="promo-code">
            LAUNCH50
          </span>{" "}
          before checkout. First 50 companies only.
        </p>
      </div>
      <button
        onClick={dismiss}
        data-testid="promo-banner-dismiss"
        aria-label="Dismiss promotion"
        className="absolute top-1/2 -translate-y-1/2 right-3 md:right-6 text-[#3b2402]/70 hover:text-[#3b2402] transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
